// React Compoment
import React from 'react';

// Features
import { UsersSignin } from '../../features/auth';
import { AuthLayout } from '../../layouts'

const SiginView = () => {
    return (
        <AuthLayout rightPanelVariant="light">
            <UsersSignin />
        </AuthLayout>
    )
}

export default SiginView;